import { css } from '@bts-web/utils-style-engine';
import { HiddenMobile } from '../LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { IMainNavigationTranslations } from '../LayoutWithLeftDesktopNav/utils/getMainNavigationTranslations';
import { ChangeLanguage } from './ChangeLanguage';
import { AppLogoWithIslamicProp } from '../LayoutWithLeftDesktopNav/Reusable/AppLogo/AppLogoWithIslamicProp.use-client';
import { AppLogo } from '../LayoutWithLeftDesktopNav/Reusable/AppLogo/AppLogo.use-client';

const containerStyles = css({
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: 'small',
  overflow: 'auto',
  backgroundColor: 'screen_background.primary',
  lg: {
    gap: 'large',
    paddingY: 'large',
    alignItems: 'center',
  },
});

const contentWrapperStyles = css({
  display: 'flex',
  height: '100vh',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: 'screen_background.primary',
  lg: {
    border: '1px solid #eaeaea',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '1',
    justifyContent: 'space-between',
    gap: 'small',
    height: 'auto',
    width: '520px',
  },
});

type Base = {
  testId?: string;
  className?: string;
};

export type ResponsiveLayoutWithLogoProps = React.PropsWithChildren<
  | (Base & {
      showLanguageSwitcher: true;
      translations: IMainNavigationTranslations;
      currentLanguage: string;
      isIslamicUser?: boolean;
    })
  | (Base & {
      showLanguageSwitcher?: false | undefined;
      translations?: IMainNavigationTranslations;
      currentLanguage?: string;
      isIslamicUser?: boolean;
    })
>;

const ResponsiveLayoutWithLogo = ({
  children,
  testId,
  showLanguageSwitcher,
  translations,
  currentLanguage,
  className,
  isIslamicUser = false,
}: ResponsiveLayoutWithLogoProps) => {
  const currentLanguageTranslations = {
    de: translations?.germanSubtitle || '',
    en: translations?.englishSubtitle || '',
    ar: translations?.arabicSubtitle || '',
    fr: translations?.frenchSubtitle || '',
  }[currentLanguage || 'de'];

  return (
    <div data-testid={testId} className={containerStyles}>
      {showLanguageSwitcher ? (
        <HiddenMobile
          className={css({
            width: '520px',
          })}
        >
          <div
            className={css({
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}
          >
            <div
              className={css({
                flex: 1,
              })}
            />
            {isIslamicUser ? (
              <AppLogo variant="default" isIslamicUser={isIslamicUser} noText />
            ) : (
              <AppLogoWithIslamicProp variant="default" noText />
            )}

            <div
              className={css({
                flex: 1,
                display: 'flex',
                justifyContent: 'flex-end',
              })}
            >
              <ChangeLanguage
                translations={translations}
                currentLanguageTranslations={
                  currentLanguageTranslations as string
                }
              />
            </div>
          </div>
        </HiddenMobile>
      ) : (
        <HiddenMobile>
          {isIslamicUser ? (
            <AppLogo variant="default" isIslamicUser={isIslamicUser} noText />
          ) : (
            <AppLogoWithIslamicProp variant="default" noText />
          )}
        </HiddenMobile>
      )}

      <div
        data-testid="content-wrapper"
        className={`${contentWrapperStyles} ${className}`}
      >
        {children}
      </div>
    </div>
  );
};

export { ResponsiveLayoutWithLogo };
